import React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {SmallCard} from '../../lib/small-card/small-card';


export const RequestMoreAvailabilitySuccess = () => {
  const {t} = useLabelTranslation();
  return (
    <SmallCard
      title={t(
        'Thank_you_we_have_captured_your_response',
        'Thank you, we have captured your response.',
      )}
      icon="badge-check"
      iconSemantic="success"
      testId="request-more-availability-success"
    >
      <div />
    </SmallCard>
  );
};
